if (!customElements.get('pdp-video')) {
  customElements.define(
    'pdp-video',
    class PdpVideo extends HTMLElement {
      constructor() {
        super();

        this.video = this.querySelector('video');
        this.playButton = this.querySelector('[data-play-btn]');

        this.playButton.addEventListener('click', () => this.video.play().catch(() => {}));
        this.video.addEventListener('play', () => (this.playButton.style.display = 'none'));
        this.video.addEventListener('pause', () => (this.playButton.style.display = ''));
        this.video.addEventListener('ended', () => (this.playButton.style.display = ''));

        // Pause when swiped to another slide or scrolled out of view
        new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) this.video.pause();
            });
          },
          { threshold: 0.1 }
        ).observe(this);
      }
    }
  );
}
